import React, { useState, useEffect, useContext } from 'react';
import 'antd/dist/antd.min.css';
import { Badge, Dropdown, Menu, Space, Table, Button, Modal, message } from 'antd';
import {
    MenuOutlined,
    InboxOutlined,
    DownOutlined,
    SmileOutlined
} from '@ant-design/icons';

import background_circle_blue_modal from 'images/background_circle_blue_modal.svg';
import icon_rename from 'images/icon_rename.svg';

import AddTopic from './modal/AddTopic';
import AddSection from './modal/AddSection';
import AddGlossaryTerm from './modal/AddGlossaryTerm';
import EditGlossaryTerm from './modal/EditGlossaryTerm';

import HelpDrawer from './drawer/HelpDrawer';

import icon_arrow_down from 'images/icon_arrow_down.svg';
import icon_arrow_up from 'images/icon_arrow_up.svg';

import {
    getHelpItem,
    createHelpItem,
    deleteHelpItem,
    editHelpItem,
    setHelpContentOrder,
    getGlossaryTerm,
    createGlossaryTerm,
    deleteGlossaryTerm,
    updateGlossaryTerm
} from 'services/help.js';
import { result } from 'lodash';
import { AppContext } from 'context/AppContext';
import HelpMenu from 'components/navigation/HelpMenu';
import HeaderHome from 'components/header/HeaderHome';
import cloneDeep from 'lodash/cloneDeep';
import { arrayMoveImmutable } from 'array-move';
import {
    SortableContainer,
    SortableElement,
    SortableHandle
} from 'react-sortable-hoc';

const menu = (
    <Menu
        items={[
            {
                key: '1',
                label: 'Action 1'
            },
            {
                key: '2',
                label: 'Action 2'
            }
        ]}
    />
);

const DragHandle = SortableHandle(() => (
    <MenuOutlined
        style={{
            cursor: 'grab',
            color: '#999'
        }}
    />
));

const SortableItem = SortableElement((props) => <tr {...props} />);
const SortableBody = SortableContainer((props) => <tbody {...props} />);

const AddHelp = () => {
    const appContext = useContext(AppContext);
    const [rerenderTable, setRerenderTable] = useState(false);
    const [rerenderGlossaryTable, setRerenderGlossaryTable] = useState(false);
    const [dataSource, setDataSource] = useState(null);
    const [glossaryDataSource, setGlossaryDataSource] = useState(null);
    // const [dataSource2, setDataSource2] = useState();

    const [addTopicTdId, setAddTopicTdId] = useState();

    const [addTopicModalIsVisible, setAddTopicModalIsVisible] = useState(false);
    const [topicName, setTopicName] = useState('');

    const showModalAddTopic = () => {};

    const handleOkAddTopic = () => {
        createHelpItem(topicName, addTopicTdId);
        setAddTopicModalIsVisible(false);
        setTimeout(() => {
            setRerenderTable(!rerenderTable);
        }, 1000);
    };

    const handleCanceladdTopic = () => {
        setAddTopicModalIsVisible(false);
    };

    const handleChangeInputAddTopic = (e) => {
        setTopicName(e.target.value);
    };
    
    // ==========================

    const [idToEditGlossary,setIdToEditGlossary] = useState();

    const [isModalVisibleEditGlossary, setIsModalVisibleEditGlossary] = useState(false);
    const [editGlossaryTerm, setEditGlossaryTerm] = useState('');
    const [editglossaryTermDescription, setEditGlossaryTermDescription] = useState('');

    const openModalEdiGlossary = (t,r,i) =>{
        setIsModalVisibleEditGlossary(true);
        setEditGlossaryTerm(t.term);
        setEditGlossaryTermDescription(t.description);
        setIdToEditGlossary(t.id)
    }

    const handleChangeInputEditGlossaryTerm = (e) => {
        setEditGlossaryTerm(e.target.value);
    };
    const handleChangeInputEditGlossaryDescription = (e) => {
        setEditGlossaryTermDescription(e)
    };

    const handleOkEditGlossary = () => {
        updateGlossaryTerm(idToEditGlossary,editGlossaryTerm,editglossaryTermDescription)
        .then((res)=>{
            if(res.status === 200){
                setIsModalVisibleEditGlossary(false);
                setEditGlossaryTerm('');
                setEditGlossaryTermDescription('');
                setTimeout(() => {
                    setRerenderGlossaryTable(!rerenderGlossaryTable);
                }, 1000);
            }
        })
        .catch((err)=>{
            let errCode = err.response.status;
            if(errCode === 404 || errCode === 500){
                message.error('Something went wrong. Please try again later.');
            }
        })
    }
    const handleCancelEditGlossary = () => {
        setIsModalVisibleEditGlossary(false)
    }

    // ==========================

    const [isModalVisibleRename, setIsModalVisibleRename] = useState(false);
    const [inputRename, setInputRename] = useState('');
    const [dataToRename, setDataToRename] = useState({});

    const showModalRename = (r) => {
        setDataToRename(r);
        setIsModalVisibleRename(true);
    };

    const handleOkRename = () => {
        editHelpItem(dataToRename.id, dataToRename.parent[0], inputRename);
        setTimeout(() => {
            setRerenderTable(!rerenderTable);
        }, 1000);
        setIsModalVisibleRename(false);
        setInputRename('');
    };

    const handleCancelRename = () => {
        setIsModalVisibleRename(false);
    };

    const handleChangeInputName = (e) => {
        setInputRename(e.target.value);
    };

    // ------------------------------

    const [addSectionModalIsVisible, setAddSectionModalIsVisible] =
        useState(false);
    const [sectionName, setSectionName] = useState('');

    const showModalAddSection = () => {};

    const handleOkAddSection = () => {
        createHelpItem(sectionName, 0);
        setAddSectionModalIsVisible(false);
        setTimeout(() => {
            setRerenderTable(!rerenderTable);
        }, 1000);
    };

    const handleCanceladdSection = () => {
        setAddSectionModalIsVisible(false);
    };

    const handleChangeInputAddSection = (e) => {
        setSectionName(e.target.value);
    };

    // ===============================
    const [addGlossaryTermModalIsVisible, setAddGlossaryTermModalIsVisible] =
        useState(false);
    const [glossaryTerm, setGlossaryTerm] = useState('');
    const [glossaryTermDescription, setGlossaryTermDescription] = useState('');

    const showModalAddGlossaryTerm = () => {};

    const handleOkAddGlossaryTerm = () => {
        createGlossaryTerm(glossaryTerm, glossaryTermDescription);
        setAddGlossaryTermModalIsVisible(false);
        setGlossaryTermDescription('');
        setGlossaryTerm('');
        setTimeout(() => {
            setRerenderGlossaryTable(!rerenderGlossaryTable);
        }, 1000);
    };

    const handleCanceladdGlossaryTerm = () => {
        // setAddSectionModalIsVisible(false);
        setGlossaryTermDescription('');
        setGlossaryTerm('');
        setAddGlossaryTermModalIsVisible(false);
    };

    const handleChangeInputAddGlossaryTerm = (e) => {
        setGlossaryTerm(e.target.value);
    };
    const handleChangeInputAddGlossaryTermDescription = (e) => {
        // setGlossaryTermDescription(e.target.value);
        setGlossaryTermDescription(e);
    };

    // ================================

    const [visibleDrawerHelp, setVisibleDrawerHelp] = useState(false);

    const showDrawerHelp = () => {
        setVisibleDrawerHelp(true);
    };

    const onCloseDrawerHelp = () => {
        setVisibleDrawerHelp(false);
    };

    const [sendDataHelpDrawer, setSendDataHelpDrawer] = useState({
        id: ''
    });

    const sendDataToHelpDrawer = (data) => {
        setSendDataHelpDrawer(data);
    };

    const compareByAlph = (a, b) => {
        if (a > b) { 
            return -1; 
        } 
        if (a < b) { 
            return 1; 
        } 
        return 0;
    }

    useEffect(() => {
        getHelpItem().then((res) => {
            let newdata = [];
            for (let index in res.data) {
                let item = res.data[index];
                let newTopics = [];
                for (let el in item.topics) {
                    let topic = item.topics[el];
                    topic['index'] = topic.id;
                    topic['order'] = topic.id;
                    newTopics.push(topic);
                }
                newdata.push({
                    id: item.id,
                    key: item.help_item,
                    title: item.title,
                    description: item.description,
                    index: item.id,
                    order: item.order,
                    name: item.name,
                    topics: newTopics
                });
            }

            setDataSource(newdata);
        });
    }, [rerenderTable]);

    useEffect(() => {
        getGlossaryTerm()
        .then((res) => {
            // console.log(`resss: `,res.data)
            // let ArrayTest = []
            // let newdata = res.data.map((item, index) => {
            //     ArrayTest.push(item.term)
            // })
            // console.log(`newdata`,ArrayTest.sort())
            setGlossaryDataSource(res.data.sort(function(a,b) {
                return a.term.localeCompare(b.term);
            }));
            // setGlossaryDataSource(res.data);
        });
    }, [rerenderGlossaryTable]);

    const expandedRowRender = (record) => {
        // const columns = [
        //     {
        //         title: 'Sort',
        //         dataIndex: 'sort',
        //         width: 30,
        //         className: 'drag-visible',
        //         render: () => <DragHandle />
        //     },
        //     {
        //         title: 'Order',
        //         dataIndex: 'order',
        //         width: 30
        //     },
        //     {
        //         title: 'Topic Name',
        //         dataIndex: 'name',
        //         key: record.id
        //     },

        //     {
        //         title: 'Action',
        //         dataIndex: 'operation',
        //         key: record.id,
        //         render: (t, r, i) => (
        //             <Button
        //                 type="primary"
        //                 onClick={() => {
        //                     showDrawerHelp(true);
        //                     sendDataToHelpDrawer(r);
        //                 }}
        //             >
        //                 menage content
        //             </Button>
        //         )
        //     },
        //     {
        //         title: '',
        //         key: 'actionn',
        //         render: (t, r, i) => (
        //             <>
        //                 <div
        //                     style={{
        //                         display: 'flex',
        //                         justifyContent: 'space-around'
        //                     }}
        //                 >
        //                     <Button
        //                         style={{
        //                             backgroundColor: '#f55757',
        //                             borderColor: '#f55757',
        //                             color: '#fff'
        //                         }}
        //                         onClick={() => {
        //                             // setAddTopicModalIsVisible(true);
        //                             // setAddTopicTdId(r.id);
        //                             deleteHelpItem(r.id);
        //                             console.log(`rrrrr`, r);
        //                             setTimeout(() => {
        //                                 setRerenderTable(!rerenderTable);
        //                             }, 1000);
        //                         }}
        //                         danger
        //                     >
        //                         Delete
        //                     </Button>
        //                     <Button
        //                         style={
        //                             {
        //                                 // backgroundColor: '#f55757',
        //                                 // borderColor: '#f55757',
        //                                 // color: '#fff'
        //                             }
        //                         }
        //                         onClick={() => {
        //                             showModalRename(r);
        //                             // deleteHelpItem(r.id);
        //                             // console.log(`rrrrr`, r);
        //                             // setTimeout(() => {
        //                             //     setRerenderTable(!rerenderTable);
        //                             // }, 1000);
        //                         }}
        //                     >
        //                         Rename
        //                     </Button>
        //                 </div>
        //             </>
        //         )
        //     }
        // ];

        // return (
        //     <Table
        //         rowKey="id"
        //         columns={columns}
        //         dataSource={record.topics}
        //         // dataSource={dataSource.topics}
        //         pagination={false}
        //     />
        // );

        const columns = [
            {
                title: 'Sort',
                dataIndex: 'sort',
                width: 30,
                className: 'drag-visible',
                render: () => <DragHandle />
            },
            {
                title: 'Topic Name',
                dataIndex: 'name',
                key: record.id
            },
            {
                title: 'Order',
                dataIndex: 'index'
            },
            {
                title: '',
                dataIndex: 'operation',
                key: record.id,
                render: (t, r, i) => (
                    <Button
                        type="primary"
                        onClick={() => {
                            showDrawerHelp(true);
                            sendDataToHelpDrawer(r);
                        }}
                    >
                        menage content
                    </Button>
                )
            },
            {
                title: '',
                key: 'actionn',
                render: (t, r, i) => (
                    <>
                        <div
                            style={{
                                display: 'flex',
                                justifyContent: 'space-around'
                            }}
                        >
                            <Button
                                style={{
                                    backgroundColor: '#f55757',
                                    borderColor: '#f55757',
                                    color: '#fff'
                                }}
                                onClick={() => {
                                    // setAddTopicModalIsVisible(true);
                                    // setAddTopicTdId(r.id);
                                    deleteHelpItem(r.id);
                                    setTimeout(() => {
                                        setRerenderTable(!rerenderTable);
                                    }, 1000);
                                }}
                                danger
                            >
                                Delete
                            </Button>
                            <Button
                                style={
                                    {
                                        // backgroundColor: '#f55757',
                                        // borderColor: '#f55757',
                                        // color: '#fff'
                                    }
                                }
                                onClick={() => {
                                    showModalRename(r);
                                    // deleteHelpItem(r.id);
                                    // console.log(`rrrrr`, r);
                                    // setTimeout(() => {
                                    //     setRerenderTable(!rerenderTable);
                                    // }, 1000);
                                }}
                            >
                                Rename
                            </Button>
                        </div>
                    </>
                )
            }
        ];

        const onSortEnd = ({ oldIndex, newIndex }) => {
            if (oldIndex !== newIndex) {
                let newRecord = cloneDeep(record);

                const newData = arrayMoveImmutable(
                    newRecord.topics.slice(),
                    oldIndex,
                    newIndex
                ).filter((el) => !!el);

                newRecord.topics = newData;
                let newDataSource = cloneDeep(dataSource);
                for (let nds in newDataSource) {
                    let r = newDataSource[nds];
                    if (r['id'] == newRecord['id']) {
                        newDataSource[nds] = newRecord;
                    }
                }

                setDataSource(newDataSource);

                let newOrder = [];

                for (let i in newData) {
                    let item = newData[i];
                    newOrder.push(item.id);
                }

                setHelpContentOrder(newRecord.topics, newOrder);
            }
        };

        const DraggableContainer = (props) => (
            <SortableBody
                useDragHandle
                disableAutoscroll
                helperClass="row-dragging"
                onSortEnd={onSortEnd}
                {...props}
            />
        );

        const DraggableBodyRow = ({ className, style, ...restProps }) => {
            // function findIndex base on Table rowKey props and should always be a right array index
            const index = record.topics.findIndex(
                (x) => x.index === restProps['data-row-key']
            );
            return <SortableItem index={index} {...restProps} />;
        };

        return (
            <Table
                pagination={false}
                dataSource={record.topics}
                columns={columns}
                rowKey="index"
                components={{
                    body: {
                        wrapper: DraggableContainer,
                        row: DraggableBodyRow
                    }
                }}
            />
        );
    };

    const columns = [
        {
            title: 'Name',
            dataIndex: 'name',
            key: 'name',
            // className: 'title-name',
            render: (t, r, i) => {
                return <div className="title-name">{r.name}</div>;
            }
        },

        {
            title: '',
            key: 'action',
            render: (t, r, i) => (
                <Button
                    type="primary"
                    onClick={() => {
                        setAddTopicModalIsVisible(true);
                        setAddTopicTdId(r.id);
                    }}
                >
                    Add Topic
                </Button>
            )
        },
        {
            title: '',
            key: 'action',
            render: (t, r, i) => (
                <>
                    <Button
                        style={{
                            backgroundColor: '#f55757',
                            borderColor: '#f55757',
                            color: '#fff'
                        }}
                        onClick={() => {
                            // setAddTopicModalIsVisible(true);
                            // setAddTopicTdId(r.id);
                            deleteHelpItem(r.id);
                            setTimeout(() => {
                                setRerenderTable(!rerenderTable);
                            }, 1000);
                        }}
                        danger
                    >
                        Delete
                    </Button>
                </>
            )
        }
    ];

    

    const glossaryColumns = [
        {
            title: 'Term',
            dataIndex: 'term',
            key: 'term',
            // className: 'title-name',
            // sorter: (a, b) => a.term.localeCompare(b.term),
            // sorter: (a, b) => compareByAlph(a.term, b.term),
            // sorter: (a, b) => { return a.dataIndex.localeCompare(b.dataIndex)},
            render: (t, r, i) => {
                return <div className="title-name">{r.term}</div>;
            },
        },

        {
            title: 'Description',
            key: 'description',
            render: (t, r, i) => {
                // return <div className="title-name">{r.description}</div>;
                return <div className="title-name" dangerouslySetInnerHTML={{__html: r.description}}></div>;
            }
        },
        {
            title: '',
            key: 'action',
            render: (t, r, i) => (
                <>
                    <Button
                        style={{
                            backgroundColor: '#f55757',
                            borderColor: '#f55757',
                            color: '#fff'
                        }}
                        onClick={() => {
                            // setAddTopicModalIsVisible(true);
                            // setAddTopicTdId(r.id);
                            deleteGlossaryTerm(r.id);
                            setTimeout(() => {
                                setRerenderGlossaryTable(!rerenderGlossaryTable);
                            }, 1000);
                        }}
                        danger
                    >
                        Delete
                    </Button>
                    <Button style={{marginLeft: '15px'}} onClick={()=>{ openModalEdiGlossary(t,r,i)}}>Edit</Button>
                </>
            )
        }

    ];

    return (
        <>
            {appContext.helpNavIsVisible ? <HelpMenu /> : null}

            <HeaderHome />

            <div className="add-help-container">
                <div className="title">Section Add Help</div>

                <Button
                    style={{ marginTop: 50 }}
                    onClick={() => {
                        setAddSectionModalIsVisible(true);
                    }}
                >
                    Add Section
                </Button>
                <Table
                    className="components-table-homeview"
                    style={{ marginTop: 10 }}
                    columns={columns}
                    expandable={{
                        expandedRowRender,

                        expandIcon: ({ expanded, onExpand, record }) =>
                            expanded ? (
                                <img
                                    style={{ cursor: 'pointer' }}
                                    src={icon_arrow_up}
                                    onClick={(e) => onExpand(record, e)}
                                />
                            ) : (
                                <img
                                    style={{ cursor: 'pointer' }}
                                    src={icon_arrow_down}
                                    onClick={(e) => onExpand(record, e)}
                                />
                            )
                        // defaultExpandedRowKeys: [62, 41, 42]
                    }}
                    dataSource={dataSource}
                    pagination={false}
                    rowKey="id"
                    // components={{
                    //     body: {
                    //         wrapper: DraggableContainer,
                    //         row: DraggableBodyRow
                    //     }
                    // }}
                />
                <div
                    className="add-glossary-term -container"
                    style={{ marginTop: 50 }}
                >
                    <div className="title">Add Glossary Term</div>

                    <Button
                        style={{ marginTop: 50 }}
                        onClick={() => {
                            setAddGlossaryTermModalIsVisible(true);
                        }}
                    >
                        Add Glossary Term
                    </Button>
                    <Table
                        className="components-table-homeview"
                        style={{ marginTop: 10 }}
                        columns={glossaryColumns}
                        dataSource={glossaryDataSource}
                        pagination={false}
                        rowKey="id"
                    />
                </div>
            </div>

            <AddTopic
                addTopicModalIsVisible={addTopicModalIsVisible}
                setAddTopicModalIsVisible={setAddTopicModalIsVisible}
                showModalAddTopic={showModalAddTopic}
                handleOkAddTopic={handleOkAddTopic}
                handleCanceladdTopic={handleCanceladdTopic}
                handleChangeInputAddTopic={handleChangeInputAddTopic}
            />

            <AddSection
                addSectionModalIsVisible={addSectionModalIsVisible}
                setAddSectionModalIsVisible={setAddSectionModalIsVisible}
                showModalAddSection={showModalAddSection}
                handleOkAddSection={handleOkAddSection}
                handleCanceladdSection={handleCanceladdSection}
                handleChangeInputAddSection={handleChangeInputAddSection}
            />

            {addGlossaryTermModalIsVisible ? (
                <AddGlossaryTerm
                    glossaryTermDescription={glossaryTermDescription}
                    addGlossaryTermModalIsVisible={
                        addGlossaryTermModalIsVisible
                    }
                    setAddGlossaryTermModalIsVisible={
                        setAddGlossaryTermModalIsVisible
                    }
                    showModalAddGlossaryTerm={showModalAddGlossaryTerm}
                    handleOkAddGlossaryTerm={handleOkAddGlossaryTerm}
                    handleCanceladdGlossaryTerm={handleCanceladdGlossaryTerm}
                    handleChangeInputAddGlossaryTerm={
                        handleChangeInputAddGlossaryTerm
                    }
                    setAddSectionModalIsVisible={setAddSectionModalIsVisible}
                    handleChangeInputAddGlossaryTermDescription={
                        handleChangeInputAddGlossaryTermDescription
                    }
                />
            ) : null}

            {isModalVisibleEditGlossary ? (
                <EditGlossaryTerm 
                    isModalVisibleEditGlossary={isModalVisibleEditGlossary}
                    editglossaryTermDescription={editglossaryTermDescription}
                    editGlossaryTerm={editGlossaryTerm}
                    handleChangeInputEditGlossaryDescription={handleChangeInputEditGlossaryDescription}
                    handleChangeInputEditGlossaryTerm={handleChangeInputEditGlossaryTerm}
                    handleCancelEditGlossary={handleCancelEditGlossary}
                    handleOkEditGlossary={handleOkEditGlossary}
                    
                />
            ):null}

            {sendDataHelpDrawer.id !== '' ? (
                <HelpDrawer
                    visibleDrawerHelp={visibleDrawerHelp}
                    setVisibleDrawerHelp={setVisibleDrawerHelp}
                    showDrawerHelp={showDrawerHelp}
                    onCloseDrawerHelp={onCloseDrawerHelp}
                    sendDataHelpDrawer={sendDataHelpDrawer}
                />
            ) : null}

            {isModalVisibleRename ? (
                <Modal
                    className="basic-modal"
                    title=""
                    visible={isModalVisibleRename}
                    onOk={handleOkRename}
                    onCancel={handleCancelRename}
                    footer={null}
                    closable={false}
                    bodyStyle={{ height: 572 }}
                    width={358}
                >
                    <div className="icon-container">
                        <img
                            className="img-icon-container"
                            src={background_circle_blue_modal}
                        />
                        <img
                            className="icon-in-green-circle"
                            style={{
                                right: '25px',
                                top: '30px',
                                height: '20px'
                            }}
                            src={icon_rename}
                        />
                    </div>
                    <div>
                        <div style={{ padding: '8px 0 0 0', marginLeft: 6 }}>
                            <p className="header-title">Rename</p>
                            <p
                                style={{
                                    fontSize: '14px',
                                    lineHeight: '18px',
                                    marginBottom: '80px'
                                }}
                            >
                                Rename Topic
                            </p>
                        </div>
                        <div style={{}}>
                            <div
                                style={{
                                    // border: '1px solid #E5E5E5',
                                    height: '33px'
                                }}
                            >
                                <input
                                    style={{
                                        padding: 5,
                                        color: '#828389',
                                        width: '100%'
                                    }}
                                    onChange={handleChangeInputName}
                                    value={inputRename}
                                />
                            </div>
                        </div>
                        <div
                            style={{ textAlign: 'center', marginTop: '160px' }}
                        >
                            <button
                                onClick={handleOkRename}
                                style={{ width: '100%' }}
                                className="ant-btn ant-btn-primary ant-btn-block blue-button"
                            >
                                OK
                            </button>
                            <Button
                                onClick={handleCancelRename}
                                style={{
                                    width: '100%',
                                    marginTop: 10,
                                    color: '#407CB1'
                                }}
                            >
                                CANCEL
                            </Button>
                        </div>
                    </div>
                </Modal>
            ) : null}
        </>
    );
};

export default AddHelp;
